/**
 * @flow
 */

import React, {Component} from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import type {Store, MyDispatch, Action} from "../actions/types.js";
import actions from "../actions";
import * as api2 from "../api2";
import * as types from "../actions/types";
import MyComponent, {type Props} from "../components/TradingViewChartOrderLine";
import {buildOrderBook, buildOpenOrdersInfo} from "../lib/ByBitUtils";

type OwnProps = {|
  tvWidget: any,
  order: types.bybitws.Order,
  position: ?types.bybitws.Position,
|};

const connector = connect<Props, OwnProps, _, _, _, _>(
  (store: Store, ownProps: OwnProps) => ({position: ownProps.position}),
  (dispatch: MyDispatch, ownProps: OwnProps) => ({
    cancelOrder: bindActionCreators(actions.bybit.cancelOrder, dispatch),
    replaceOrder: bindActionCreators(actions.bybit.replaceOrder, dispatch),
  }),
);

const Connected: * = connector(MyComponent);
export default Connected;

function test(props: OwnProps) {
  return <Connected {...props} />;
}
